export const priceConstants = {
  GETALL_REQUEST: 'PRICES_GETALL_REQUEST',
  GETALL_SUCCESS: 'PRICES_GETALL_SUCCESS',
  GETALL_FAILURE: 'PRICES_GETALL_FAILURE',

  GET_REQUEST: 'PRICES_GET_REQUEST',
  GET_SUCCESS: 'PRICES_GET_SUCCESS',
  GET_FAILURE: 'PRICES_GET_FAILURE',

  ADD_REQUEST: 'PRICES_ADD_REQUEST',
  ADD_SUCCESS: 'PRICES_ADD_SUCCESS',
  ADD_FAILURE: 'PRICES_ADD_FAILURE',

  UPDATE_REQUEST: 'PRICES_UPDATE_REQUEST',
  UPDATE_SUCCESS: 'PRICES_UPDATE_SUCCESS',
  UPDATE_FAILURE: 'PRICES_UPDATE_FAILURE',
}